import React, { useEffect } from 'react';

import { Grid } from '../../components/Grid.components';
import { Text } from '../../components/Text.components';
import { Boxed } from '../../components/Boxed.components';
import { PageTitle } from '../../components/style';

import { truncateText } from '../../utils/utils';
import { Theme } from '../../utils/theme';

import Applications from '../Applications/index';
import { USER_TYPE } from '../../utils/constant';

export const RequestTotalCard = ({ status }) => {
  return (
    <Boxed
      pad="15px"
      borderRadius={Theme.PrimaryRadius}
      background={Theme.TertiaryDark}
      boxShadow={Theme.boxShadow}
      height="100%"
      cursor="pointer"
    >
      <Boxed>
        <Text fontWeight="600" cursor="pointer" transform="capitalize">
          {status?._id} requests
        </Text>
      </Boxed>
      <Text padding="5px 0" fontSize="28px" fontWeight="600">
        {status?.totalCount}
      </Text>
    </Boxed>
  );
};

export const Dashboard = (props) => {
  // state props
  const {
    openApplicationFormsList,
    openApplicationFormsTotal,
    closedApplicationFormsList,
    closedApplicationFormsTotal,
    accessList,
    requestFormsList,
    fetchActionOpen,
    fetchActionClose,
    companyAggerateRequest,
    profile,
    userAggerateRequest
  } = props;

  // dispatch props
  const {
    redirect,
    fetchRequestForms,
    fetchTotalCompanyRequest,
    fetchTotalUserRequest,
    fetchApplicationStats
  } = props;

  // const Theme = useContext(ThemeConsumer)
  useEffect(() => {
    let data = {
      page: 1,
      limit: 3
    };
    fetchRequestForms(data);
    fetchTotalCompanyRequest(data);
    fetchTotalUserRequest(profile?._id);
    fetchApplicationStats();
  }, []);

  const RequestFormCard = ({ data }) => {
    return (
      <Boxed
        pad="15px"
        borderRadius={Theme.PrimaryRadius}
        background={Theme.TertiaryDark}
        boxShadow={Theme.boxShadow}
        height="100%"
        cursor="pointer"
        onClick={() => console.log(data._id)}
      >
        <Boxed>
          <Text fontWeight="600" cursor="pointer">
            {data?.title}
          </Text>
        </Boxed>
        <Text padding="5px 0" color={Theme.SecondaryTextColor} fontSize={Theme.SecondaryFontSize}>
          {data?.description && truncateText(data?.description, 80)}
        </Text>
        <Text padding="5px 0" fontSize={Theme.SecondaryFontSize}>
          {' '}
          <span>{data?.fields?.length ?? 0}</span> Fields, <span>{data?.steps?.length ?? 0}</span>{' '}
          Steps
        </Text>
      </Boxed>
    );
  };


  return (
    <>
      <Boxed pad="20px">
        <Grid desktop="repeat(4, 1fr)" tablet="repeat(3, 1fr)" mobile="repeat(1, 1fr)">
          {accessList[USER_TYPE?.ACCOUNT_DIRECTOR] || accessList[USER_TYPE?.ADMINSTRATOR] ? (
            <>
              {companyAggerateRequest?.map((request, index) => (
                <RequestTotalCard key={index} status={request} />
              ))}
            </>
          ) : (
            <>
              {userAggerateRequest?.map((request, index) => (
                <RequestTotalCard key={index} status={request} />
              ))}
            </>
          )}
        </Grid>

        <Boxed>
          <PageTitle>Recent Request(s)</PageTitle>
          <Grid desktop="repeat(4, 1fr)" tablet="repeat(3, 1fr)" mobile="repeat(1, 1fr)">
            {requestFormsList?.slice(0, 4)?.map((item, index) => {
              return (
                <Boxed pad="5px" key={index}>
                  <RequestFormCard data={item} />
                </Boxed>
              );
            })}
          </Grid>
        </Boxed>
        <Boxed pad="10px 0">
          <PageTitle margin="5px 0">Open Request(s)</PageTitle>
          <Applications
            fetchActionURL={fetchActionOpen}
            contentList={openApplicationFormsList}
            contentTotal={openApplicationFormsTotal}
            hideSearch={true}
            hidePagination={true}
            defaultLimit={3}
          />
          {openApplicationFormsTotal > 3 && (
            <Boxed display="flex">
              <Text
                margin="0 10px 0 auto"
                color={Theme.PrimaryColor}
                cursor="pointer"
                onClick={() => redirect('/applications')}
              >
                See More...
              </Text>
            </Boxed>
          )}
        </Boxed>

        <Boxed pad="10px 0">
          <PageTitle margin="5px 0">Recently Completed Request(s)</PageTitle>
          <Applications
            fetchActionURL={fetchActionClose}
            contentList={closedApplicationFormsList}
            contentTotal={closedApplicationFormsTotal}
            hideSearch={true}
            hidePagination={true}
            defaultLimit={3}
          />
          {closedApplicationFormsTotal > 3 && (
            <Boxed display="flex">
              <Text
                margin="0 10px 0 auto"
                color={Theme.PrimaryColor}
                cursor="pointer"
                onClick={() => redirect('/applications')}
              >
                See More...
              </Text>
            </Boxed>
          )}
        </Boxed>
      </Boxed>
    </>
  );
};
